import type { MockBackofficePrincipal } from './types';

const superAdminPermissions = [
  'AGENT_MANAGE',
  'AGENT_VIEW',
  'CREDENTIAL_MANAGE',
  'COMMISSION_RULE_APPROVE',
  'COMMISSION_RULE_MANAGE',
  'COMMISSION_RULE_VIEW',
  'GAME_MANAGE',
  'GAME_VIEW',
  'MEMBER_MANAGE',
  'MEMBER_VIEW',
  'PARTNER_MANAGE',
  'PARTNER_VIEW',
  'AUDIT_VIEW',
  'BACKOFFICE_USER_MANAGE',
  'TRANSACTION_VIEW',
  'COMMISSION_LEDGER_VIEW',
  'WALLET_VIEW',
  'WITHDRAWAL_VIEW',
  'APPROVAL_DECIDE',
  'WALLET_STATUS_MANAGE',
  'WALLET_ADJUST',
  'WITHDRAWAL_RETRY',
  'WITHDRAWAL_RESOLVE',
  'WITHDRAWAL_POLICY_MANAGE',
  'INTEGRATION_MANAGE',
  'REPORT_VIEW',
  'REPORT_EXPORT',
  'RECONCILIATION_MANAGE',
];

export const mockSuperAdmin: MockBackofficePrincipal = Object.freeze({
  actor: {
    id: '00000000-0000-4000-8000-000000000001',
    displayName: 'Mock Super Admin',
  },
  username: 'mock-super-admin',
  email: 'mock.super.admin@example.test',
  role: 'SUPER_ADMIN',
  status: 'ACTIVE',
  scope: { partnerId: null, agentId: null, permissionProfileId: null },
  permissions: superAdminPermissions,
  issuer: 'mock://affiliate-platform/backoffice',
  subject: 'mock-super-admin',
  mockData: true,
});
